<template>
  <div class="list-container">
    <h1>環境測定情報一覧</h1>

    <div>
      <h3>修正中報告書一覧</h3>
      <table class="table table-bordered">
        <thead class="table-dark">
          <tr>
            <th class="text-nowrap">顧客名</th>
            <th class="text-nowrap">建物名</th>
            <th class="text-nowrap">測定日</th>
            <th class="text-nowrap">測定者</th>
            <th class="text-nowrap">補助者</th>
            <th class="text-nowrap">測定ポイント数</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="measurement_report in fixing_measurement_reports" :key="measurement_report.id">
            <td>{{ measurement_report.m_customer.customer_nm }}</td>
            <td>{{ measurement_report.m_building.building_nm }}</td>
            <td class="text-nowrap">{{ measurement_report.measure_dt }}</td>
            <td class="text-nowrap">{{ measurement_report.measure_person }}</td>
            <td class="text-nowrap">{{ measurement_report.assistant }}</td>
            <td class="text-nowrap">{{ measurement_report.point_count }}</td>
            <td class="btn-cell text-nowrap">
              <!-- <router-link :to="{ name: 'MeasurementReportCopyCreate', params: { id: measurement_report.id }}">
                <button type="button" class="btn btn-warning mx-1">コピー</button>
              </router-link> -->

              <router-link :to="{ name: 'MeasurementReportDetail', params: { id: measurement_report.id }}"> <!-- 報告書詳細ページへのリンク -->
                <button type="button" class="btn btn-info mx-1">詳細</button>
              </router-link>

              <router-link :to="{ name: 'CustomerMeasurementReportEdit', params: { id: measurement_report.id, customer_id: measurement_report.m_customer_id, building_id: measurement_report.m_building_id }}"> <!-- 建物情報編集ページへのリンク -->
                <button type="button" class="btn btn-success mx-2">編集</button>
              </router-link>

              <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(measurement_report.id)">削除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 検索バーの追加
    <div class="search-container p-3 my-3" style="background-color: #f8f9fa;">
      <div class="row g-3 align-items-center">

        
        <div class="col-auto">
          <label for="searchCustomerName" class="col-form-label">顧客名</label>
        </div>
        <div class="col-auto">
          <select id="searchCustomerName" class="form-select" v-model="searchCustomerName" placeholder="顧客名で検索">
            <option value="" disabled selected>選択してください</option>
            <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{ customer.customer_nm }}</option>
          </select>
        </div>

        
        <div class="col-auto">
          <label for="searchBuildingName" class="col-form-label">建物名</label>
        </div>
        <div class="col-auto">
          <select id="searchBuildingName" class="form-select" v-model="searchBuildingName" placeholder="建物名で検索">
            <option value="" disabled selected>選択してください</option>
            <option v-for="buliding in buildings" :key="buliding.id" :value="buliding.id">{{ buliding.buliding_nm }}</option>
          </select>
        </div>

        

        <div class="col-auto">
          <button class="btn btn-primary mx-1" @click="searchMeasurementReports">検索</button>
          <button class="btn btn-secondary mx-1" @click="searchResetMeasurementReports">クリア</button>
        </div>
      </div>
    </div>-->


    <div>
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <h3 class="mb-0">登録済み報告書一覧</h3>
        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @change-page="handleChangePage"
        />
      </div>

      <table class="table table-bordered">
        <thead class="table-dark">
          <tr>
            <th>顧客名</th>
            <th>建物名</th>
            <th>測定日</th>
            <th>測定者</th>
            <th>補助者</th>
            <th>測定ポイント数</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="measurement_report in measurement_reports" :key="measurement_report.id">
            <td>{{ measurement_report.m_customer.customer_nm }}</td>
            <td>{{ measurement_report.m_building.building_nm }}</td>
            <td>{{ measurement_report.measure_dt }}</td>
            <td>{{ measurement_report.measure_person }}</td>
            <td>{{ measurement_report.assistant }}</td>
            <td>{{ measurement_report.point_count }}</td>
            <td class="btn-cell text-nowrap">
              <router-link :to="{ name: 'CustomerMeasurementReportCopy', params: { id: measurement_report.id, customer_id: measurement_report.m_customer_id, building_id: measurement_report.m_building_id }}">
                <button type="button" class="btn btn-warning mx-1">コピー</button>
              </router-link>

              <router-link :to="{ name: 'MeasurementReportDetail', params: { id: measurement_report.id }}"> <!-- 報告書詳細ページへのリンク -->
                <button type="button" class="btn btn-info mx-1">詳細</button>
              </router-link>

              <router-link :to="{ name: 'CustomerMeasurementReportEdit', params: { id: measurement_report.id, customer_id: measurement_report.m_customer_id, building_id: measurement_report.m_building_id }}"> <!-- 建物情報編集ページへのリンク -->
                <button v-if="isWithinTwoMonths(measurement_report.created_at)" type="button" class="btn btn-success mx-2">編集</button>
                <button v-if="!isWithinTwoMonths(measurement_report.created_at)" type="button" class="btn btn-success mx-2" disabled>編集</button>
              </router-link>

              <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(measurement_report.id)">削除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 削除確認モーダル -->
    <DeleteConfirmationModal
      :paramsId="paramsIdToDelete"
      @confirmDelete="handleConfirmDelete"
    />
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
// import { getBuildingMeasurementReports, getFixingBuildingMeasurementReports, getCustomers, getBuildings, deleteMeasurementReport } from '@/api/axios';
import { getBuildingMeasurementReports, getFixingBuildingMeasurementReports, deleteMeasurementReport } from '@/api/axios';
import DeleteConfirmationModal from '@/components/shared/DeleteConfirmationModal.vue';
import Pagination from '@/components/shared/Pagination.vue';

export default {
  components: {
    DeleteConfirmationModal,
    Pagination
  },
  setup() {
    const title = ref('環境測定情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    // const customers = ref([]);
    // const buildings = ref([]);
    const measurement_reports = ref([]);
    const fixing_measurement_reports = ref([]);
    const customerId = route.params.customer_id;
    const buildingId = route.params.building_id;

    // 検索用のデータプロパティ
    // const searchCustomerName = ref('');
    // const searchBuildingName = ref('');
    // const searchMeasureDate = ref('');
    // const searchMeasurePerson = ref('');

    // 削除モーダルへ渡すID
    const paramsIdToDelete = ref(null);

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const fetchMeasurementReports = async (page = 1) => {
      // 登録済み報告書
      try {
        const response = await getBuildingMeasurementReports(customerId, buildingId, { page: page });
        measurement_reports.value = response.data.measurement_reports;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
      } catch (error) {
        console.error('環境測定情報ーデータの取得に失敗しました:', error);
      }

      // 修正中報告書
      try {
        const response = await getFixingBuildingMeasurementReports(customerId, buildingId, { page: page });
        fixing_measurement_reports.value = response.data.measurement_reports;
      } catch (error) {
        console.error('環境測定情報ーデータの取得に失敗しました:', error);
      }

      // 顧客情報（検索用）
      // try {
      //   const response = await getCustomers();
      //   customers.value = response.data.customers;
      // } catch (error) {
      //   console.error('顧客情報ーデータの取得に失敗しました:', error);
      // }

      // // 建物情報（検索用）
      // try {
      //   const response = await getBuildings();
      //   buildings.value = response.data.buildings;
      // } catch (error) {
      //   console.error('建物情報ーデータの取得に失敗しました:', error);
      // }
    };
    
    // 報告書作成日が2ヶ月前かどうか
    const isWithinTwoMonths = (createdAt) => {
      const today = new Date();
      const t_month = today.getMonth();
      const twoMonthsAgo = new Date();

      twoMonthsAgo.setMonth(t_month - 2);
      const reportCreatedAt = new Date(createdAt);

      return reportCreatedAt > twoMonthsAgo;
    };

    const handleChangePage = async (page) => {
      if (page < 1 || page > totalPages.value) return;
      await fetchMeasurementReports(page);
    };

    const handleDeleteClick = (measurement_reportId) => {
      paramsIdToDelete.value = measurement_reportId;
    };
    
    const handleConfirmDelete = async (measurement_reportId) => {
      try {
        await deleteMeasurementReport(measurement_reportId);
        // リストから測定情報ーを削除
        measurement_reports.value = measurement_reports.value.filter(measurement_report => measurement_report.id !== measurement_reportId);
        fixing_measurement_reports.value = fixing_measurement_reports.value.filter(measurement_report => measurement_report.id !== measurement_reportId);
        store.commit('setFlashMessage', { message: '環境測定情報が削除されました', type: 'success' });
        router.push(`/building-measurement-reports/${customerId}/${buildingId}`);
      } catch (error) {
        // エラー処理
        store.commit('setFlashMessage', { message: '環境測定情報削除に失敗しました', type: 'danger' });
      }
    };

    // 測定報告書を検索するメソッド
    // const searchMeasurementReports = async () => {
    //   try {
    //     const response = await getBuildingMeasurementReports({
    //       customer_id: searchCustomerName.value,
    //       building_id: searchBuildingName.value,
    //       measure_dt: searchMeasureDate.value,
    //       measure_person: searchMeasurePerson.value
    //     });
    //     measurement_reports.value = response.data.measurement_reports;
    //     totalPages.value = response.data.meta.total_pages; // トータルページ数をセット
    //     currentPage.value = 1; // 現在のページを1にリセット
    //   } catch (error) {
    //     console.error('検索中にエラーが発生しました:', error);
    //   }
    // };

    // 測定報告書を検索リセットするメソッド
    // const searchResetMeasurementReports = async () => {
    //   try {
    //     const response = await getBuildingMeasurementReports({
    //       customer_id: '',
    //       building_id: '',
    //       measure_dt: '',
    //       measure_person: ''
    //     });
    //     measurement_reports.value = response.data.measurement_reports;
    //     totalPages.value = response.data.meta.total_pages; // トータルページ数をセット
    //     currentPage.value = 1; // 現在のページを1にリセット
    //     searchCustomerName.value = '';
    //     searchBuildingName.value = '';
    //     searchMeasureDate.value = '';
    //     searchMeasurePerson.value = '';
    //   } catch (error) {
    //     console.error('検索中にエラーが発生しました:', error);
    //   }
    // };

    onMounted(fetchMeasurementReports);

    return {
      title,
      // customers,
      // buildings,
      measurement_reports,
      fixing_measurement_reports,
      isWithinTwoMonths,
      paramsIdToDelete,
      handleDeleteClick,
      handleConfirmDelete,
      // searchCustomerName,
      // searchBuildingName,
      // searchMeasureDate,
      // searchMeasurePerson,
      currentPage,
      totalPages,
      handleChangePage,
      // searchMeasurementReports,
      // searchResetMeasurementReports
    };
  }
};
</script>

<style scoped>
.list-container {
  padding: 20px 20px 80px 20px;
  margin: auto;
}

.measurement-report-item {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.measurement_report-item:hover {
  background-color: #f5f5f5;
}.building-item:hover {
  background-color: #f5f5f5;
}

table .btn-cell{
  width: 320px;
  min-width: 320px;
  max-width: 320px;
}
</style>
